import React from 'react'
import {FaGithub} from 'react-icons/fa'
import {IoLogoDiscord} from 'react-icons/io5'

function HeaderSocials() {
  return (
    <div className='header__socials'>
        <a href="https://github.com/Killerhunter100" target='_blank' rel='noreferrer'><FaGithub/></a>
        <a href="https://discord.gg/gEwsEn7WYy" target='_blank' rel='noreferrer'><IoLogoDiscord/></a>
    </div>
  )
}

export default HeaderSocials